import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage';

const CenterLeftMenu = () => import('WX/views/CenterLeftMenu.vue');
const Login = () => import('WX/views/Login/Login.vue');
const ChatAnonymity = () => import('WX/views/ChatAnonymity/ChatAnonymity.vue');
const Timeout = () => import('WX/views/ErrorHandle/Timeout.vue');
const Offline = () => import('WX/views/ErrorHandle/Offline.vue');
const Home = () => import('WX/views/Home/Home.vue');
const ErrorMsg = () => import('WX/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('WX/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('WX/views/Register/Register.LinkFailure.vue');
const Bet = () => import('WX/views/Bet/Bet.vue');

const AccountInfo = () => import('WX/views/AccountCenter/AccountInfo.vue');
const AwardDetail = () => import('WX/views/AwardDetail/AwardDetail.vue');
const MyDailyPayAndContract = () => import('WX/views/MyDailyPayAndContract/MyDailyPayAndContract.vue');
const AccountSecurity = () => import('WX/views/AccountCenter/AccountSecurity.vue');
const LoginRecord = () => import('WX/views/LoginRecord/LoginRecord.vue');
const DepositRequestCreate = () => import('WX/views/DepositRequest/Create.vue');
const DepositQrcode = () => import('WX/views/DepositRequest/DepositQrcode.vue');
const DepositPayInfo = () => import('WX/views/DepositRequest/PayInfo.vue');
const DownloadHuangingupApplication = () => import('WX/views/Download/HangingUpApplication.vue');
const AndroidDownload = () => import('WX/views/Download/AndroidDownload.vue');
const iosDownload = () => import('WX/views/Download/iosDownload.vue');
const CreatePlayer = () => import('WX/views/Player/Player.Create.vue');
const Player = () => import('WX/views/Player/Player.vue');
const BonusManagement = () => import('WX/views/BonusManagement/BonusManagement.vue');
const ProportionalDividend = () => import('WX/views/ProportionalDividend/ProportionalDividend.vue');
const TradeAgreement = () => import('WX/views/Login/TradeAgreement.vue');
const HelperCenter = () => import('WX/views/Home/HelperCenter.vue')
const WithdrawRequest = () => import('WX/views/WithdrawRequest/WithdrawRequest.vue');
const RegisterLink = () => import('WX/views/RegisterLink/RegisterLink.vue');
const BankCard = () => import('WX/views/BankCard/BankCard.vue')
const CreateBankCard = () => import('WX/views/BankCard/BankCard.Create.vue');
const CreateAliPay = () => import('WX/views/BankCard/AliPay.Create.vue');
const CreateWeChat = () => import('WX/views/BankCard/WeChat.Create.vue');
const CreateENCY = () => import('WX/views/BankCard/ENCY.Create.vue');
const Register = () => import('WX/views/Register/Register.vue');
const DepositAndWithdrawRecord = () => import('WX/views/DepositAndWithdrawRecord/DepositAndWithdrawRecord.vue');
const ExternalGameTransRecord = () => import('WX/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const ExternalGameSubItem = () => import('WX/views/ExternalGame/ExternalGameSubItem.vue');
const TrendChartStatistics = () => import('WX/views/TrendChart/Statistics.vue');
const TrendChartOverview = () => import('WX/views/TrendChart/Overview.vue');
const TransferPointRecord = () => import('WX/views/TransferPointRecord/TransferPointRecord.vue');
const Transfer = () => import('WX/views/TransferPoint/Transfer.vue');
const UserStatisticsReport = () => import('WX/views/UserStatisticsReport/UserStatisticsReport.vue');
const BetRecord = () => import('WX/views/BetRecord/BetRecord.Main.vue');
const DividendRecord = () => import('WX/views/DividendRecord/DividendRecord.vue');
const ProfitReport = () => import('WX/views/ProfitReport/ProfitReport.Main.vue');
const ScheduleRecord = () => import('WX/views/ScheduleRecord/ScheduleRecord.Main.vue');
const CashFlowRecord = () => import('WX/views/CashFlowRecord/CashFlowRecord.Main.vue');
const LotteryGameStatistics = () => import('WX/views/LotteryGameStatistics/LotteryGameStatistics.Main.vue');
const DrawHistory = () => import('WX/views/DrawHistory/DrawHistory.vue');
const CreateUSDTAddress = () => import('WX/views/USDTAddress/USDTAddress.Create.vue');
const LegendDownload = () => import('WX/views/Download/LegendDownload.vue');
const LoginDownload = () => import('WX/views/Download/LoginDownload.vue');
const FrequentlyUsedAppGuide = () => import('WX/views/Download/FrequentlyUsedAppGuide.vue');
const ElectronicPurseManualCreate = () => import('WX/views/ElectronicPurse/ElectronicPurse.create.manual.vue');
const ElectronicPurseQRCodeCreate = () => import('WX/views/ElectronicPurse/ElectronicPurse.create.qrcode.vue');
const Activity = () => import('WX/views/Activity/Activity.vue');
Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/TradeAgreement', component: TradeAgreement, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/DepositPayInfo/:SerialNumber', name: 'DepositPayInfo', component: DepositPayInfo, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        { path: '/', name: 'Home', component: Home},
        { path: '/Bet/:id', name: 'Bet', component: Bet },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode },
        { path: '/HangingUpApplication', component: DownloadHuangingupApplication },
        { path: '/AndroidAppDownload', component: AndroidDownload },
        { path: '/iosAppDownload', component: iosDownload },
        { path: '/HelperCenter', component: HelperCenter },
        { path: '/ExternalGameSubItem/:gameType', component: ExternalGameSubItem },
        { path: '/LegendDownload', component: LegendDownload },
        { path: '/LoginDownload', component: LoginDownload },
        { path: '/FrequentlyUsedAppGuide', component: FrequentlyUsedAppGuide },
        { path: '/Activity', name: 'Activity', component: Activity },
        {
            path: '/Center', component: CenterLeftMenu,
            children: [
                { path: 'AccountInfo', component: AccountInfo },
                { path: 'AwardDetail', component: AwardDetail },
                { path: 'MyDailyPayAndContract', component: MyDailyPayAndContract }, 
                { path: 'BankCard', name: 'BankCard', component: BankCard },
                { path: 'CreateBankCard', name: 'CreateBankCard', component: CreateBankCard },
                { path: '/CreateAliPay/:CurrentBankType', name: 'CreateAliPay', component: CreateAliPay, props: true },
                { path: '/CreateWeChat/:CurrentBankType', name: 'CreateWeChat', component: CreateWeChat, props: true },
                { path: '/CreateECNY/:CurrentBankType', name: 'CreateENCY', component: CreateENCY, props: true },
                { path: 'AccountSecurity', component: AccountSecurity },
                { path: 'LoginRecord', component: LoginRecord },
                { path: 'DepositCreate', component: DepositRequestCreate },
                { path: 'CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true} },
                { path: 'Player', component: Player, meta: { isAgentAllow: true} },
                { path: 'BonusManagement', component: BonusManagement, meta: { isAgentAllow: true} },
                { path: 'ProportionalDividend', component: ProportionalDividend, meta: { isAgentAllow: true} },
                { path: 'WithdrawRequest', component: WithdrawRequest },   
                { path: 'RegisterLink', component: RegisterLink, meta: { isAgentAllow: true} },
                { path: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: 'DepositAndWithdrawRecord', component: DepositAndWithdrawRecord },
                { path: 'TrendChartStatistics', component: TrendChartStatistics, meta: { isAgentAllow: true} },
                { path: 'TrendChartOverview', component: TrendChartOverview, meta: { isAgentAllow: true} },
                { path: 'TransferPointRecord', component: TransferPointRecord },
                { path: 'UserStatisticsReport', component: UserStatisticsReport, meta: { isAgentAllow: true} },
                { path: 'Transfer', name:'Transfer', component: Transfer },
                { path: 'BetRecord',name:'BetRecord', component: BetRecord},
                { path: 'DividendRecord',name:'DividendRecord', component: DividendRecord},
                { path: 'ProfitReport', component: ProfitReport },
                { path: 'ScheduleRecord', component: ScheduleRecord },
                { path: 'CashFlowRecord', component: CashFlowRecord },
                { path: 'LotteryGameStatistics', component: LotteryGameStatistics },
                { path: 'CreateUSDTAddress/:currencyType', name: 'CreateUSDTAddress', component: CreateUSDTAddress },
                { path: 'CreateElectronicPurseManual', name: 'ElectronicPurseManualCreate', component: ElectronicPurseManualCreate, props: true },
                { path: 'CreateElectronicPurseQRCode', name: 'ElectronicPurseQRCodeCreate', component: ElectronicPurseQRCodeCreate, props: true },
            ]
        },
        { path: '/DrawHistory/:id',name:'DrawHistory', component: DrawHistory },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == "Login") {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some(record => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some(record => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        }
        else if (to.name === "Home" && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/speedtest');
        }
        else {
            next('/Timeout');   // 認證已過期
        }
    }
});

export default router;